import Vue from "vue";
import Vuex from "vuex";

import media from "./modules/media";
import context from "./modules/context";
import authentication from "./modules/authentication";
import page from "./modules/page";
import modals from "./modules/modals";

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        media,
        context,
        authentication,
        page,
        modals,
    },
});
export default store;